import { render, staticRenderFns } from "./unicomDeal7.vue?vue&type=template&id=aa8d66fe&scoped=true"
import script from "./unicomDeal7.vue?vue&type=script&lang=js"
export * from "./unicomDeal7.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal7.vue?vue&type=style&index=0&id=aa8d66fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8d66fe",
  null
  
)

export default component.exports